module.exports = __webpack_public_path__ + "static/media/playground1.1b8587f4.mov";